import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { KYC_INVITE_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class KycInviteRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = KYC_INVITE_URL;

  constructor(request) {
    super();

    this.body = request;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
